import { Button, Stack } from '@mui/material';
import { CheckIcon } from '@schooly/style';
import { FC, PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

type ExpandedSelectFooterButtonsProps = PropsWithChildren<{
  onApply: () => void;
  onClear?: () => void;
}>;

export const ExpandedSelectFooterButtons: FC<ExpandedSelectFooterButtonsProps> = ({
  children,
  onApply,
  onClear,
}) => {
  const { formatMessage } = useIntl();
  return (
    <>
      {children}
      <Stack height={32} />
      <Stack
        bgcolor="background.paper"
        position="absolute"
        right={15}
        bottom={0}
        left={0}
        flexDirection="row"
        gap={1}
        p={1}
        alignItems="center"
      >
        <Button size="small" onClick={onApply} startIcon={<CheckIcon />}>
          {formatMessage({ id: 'filter-Apply-filter' })}
        </Button>

        {!!onClear && (
          <Button size="small" variant="outlined" onClick={onClear}>
            {formatMessage({ id: 'filter-Clear-short' })}
          </Button>
        )}
      </Stack>
    </>
  );
};
